<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">회원 예치금 관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>회원 ID</p>
                <input type="text" placeholder="회원 ID를 입력하세요" class="form_control" v-model="searchInfo.clinic_doctor_id">
              </li>
              <li>
                <p>회원명</p>
                <input type="text" placeholder="회원명를 입력하세요" class="form_control" v-model="searchInfo.doctor_nm">
              </li>
              <li>
                <p>한의원명</p>
                <input type="text" placeholder="한의원명를 입력하세요" class="form_control" v-model="searchInfo.clinicNm">
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue" @click="fn_move_deposit_reg">예치금 등록</button>
            </div>
            <table class="list">
              <thead>
                <tr>
                  <th>회원 ID</th>
                  <th>회원명</th>
                  <th>휴대전화번호</th>
                  <th>한의원명</th>
                  <th>전화번호</th>
                  <th>이메일</th>
                  <th>예치금</th>
                  <th>상세보기</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in depositInfoList" :key="index">
                  <td><span>{{ item.clinic_doctor_id }}</span></td>
                  <td><span>{{ item.doctor_nm }}</span></td>
                  <td><span>{{ formatPhoneNumber(item.doctor_phone_num) }}</span></td>
                  <td><span>{{ item.clinic_nm }}</span></td>
                  <td><span>{{ formatPhoneNumber(item.clinic_tel_num) }}</span></td>
                  <td><span>{{ item.doctor_email }}</span></td>
                  <td>
                    <span>{{ fn_comma_won(item.deposit_balance) }}</span>
                  </td>
                  <td>
                    <button class="btn btn_sm btn_outline" @click="fn_move_deposit_dtl(item)">상세보기</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo=searchInfo.pageInfo @clickPage="fn_moveGrpPage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>
  import axios from 'axios'
  import Pagination from "@/components/AdminPagination.vue"
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'UserMngtList',
    mixins: [commonUtil],
    components: {
      Pagination
    },
    data() {
      return {
        searchInfo : {
          clinic_doctor_id : '',
          doctor_nm : '',
          clinic_nm : '',
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }                
        },
        pagingShow : false,
        depositInfoList: [],
        searchInfoChange : false,
        classTypeList : []
      }
    },
    async created(){

      this.classTypeList = await this.getCode('GC00000002');

      //검색정보 처리
        let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
        if(searchInfoStore != null && searchInfoStore != {}){
            this.searchInfo = searchInfoStore
        }
    },
    mounted(){
      this.fn_search();
    },
    methods : {
      fn_search_change(){
        //검색 정보 변경 여부
        let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];

        if(searchInfoStore != null && searchInfoStore != {}){
            if(this.searchInfo.clinic_doctor_id != searchInfoStore.clinic_doctor_id){
              this.searchInfoChange = true;
            }
            if(this.searchInfo.doctor_nm != searchInfoStore.doctor_nm){
              this.searchInfoChange = true;
            }
            if(this.searchInfo.clinic_nm != searchInfoStore.clinic_nm){
              this.searchInfoChange = true;
            }
        }
      },
      fn_search(){

            this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo);

            axios
                .post("/api/admin/userMngt/getDepositInfoList", this.searchInfo)
                .then((res) => {
                    this.depositInfoList = res.data.depositInfoList;

                    console.log("@@@@ depositInfoList : %o",this.depositInfoList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                    
                    if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                    }else{
                      this.pagingShow = false; 
                    }                        

                })
                .catch((err) => console.log(err));
        },
        fn_moveGrpPage(page){
          this.searchInfo.pageInfo.page = page;
          this.fn_search();
        },
        fn_move_deposit_reg(){
            this.$router.push({ name : 'userDepositReg'});
        },
        fn_move_deposit_dtl(item){
            this.$store.dispatch('userMngt/setClinicDoctorInfo', item);
            this.$router.push({ name : 'userDepositDtl'});
        }

    }
  }
</script>